/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TInspectorNode } from "../InspectorNodeTypes";
import { ISchemaBuilderAnyModel, isSchemaBuilderAnyModel } from "@adapptio/lib-blueprint";
import { mapModelToNodes } from "../index";
import { IInspectorControl_BuilderAny, INSPECTOR_CONTROL_TYPE } from "../controls";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";

export function builderAnyMapper(model: ISchemaBuilderAnyModel): TInspectorNode {
	if (!isSchemaBuilderAnyModel(model)) {
		return;
	}

	const control: IInspectorControl_BuilderAny = {
		key: String(model.nodeId),
		type: INSPECTOR_CONTROL_TYPE.BUILDER_ANY,
		model
	};

	const valueNode = mapModelToNodes(model.value);
	const valueControls = valueNode?.controls || [];

	return {
		...valueNode,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		required: model.schema.opts["constraints"]?.required || false,
		default: model.schema.opts["default"] || null,
		options: model.schema.opts["options"],
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		tooltip: model.schema.opts.description,
		deps: [ model, ...(valueNode?.deps || []) ],
		controls: [ control, ...valueControls ]
	};
}
